export default "__VITE_ASSET__CfSdO6ud__"